import { combineReducers } from "redux";
import schema from "./schema";
import format from "./format";
import structure from "./structure";
import endpoint from "./endpoint";
import schedule from "./schedule";
import contacts from "./contacts";

export default combineReducers({
  schema,
  format,
  structure,
  endpoint,
  schedule,
  contacts
});



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/index.ts